import React from 'react';
import styled from 'styled-components';

import Typography, { VARIANTS } from '@jobcase/react_pattern_library/components/Typography';
import styles from '@jobcase/react_pattern_library/styles/rebrand';

const Bars = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin: ${styles.spacing.small}px 0;
  width: 100%;

  ::before, ::after {
    border-top: 2px solid ${styles.color.dividerGrayColor};
    content: "";
    display: block;
    height: 0;
    width: 100%;
  }

  ::before {
    margin-right: 1px;
  }

  ::after {
    margin-left: 1px;
  }
`;

const StyledTypography = styled(Typography)`
  color: ${styles.color.primaryColorDisabled};
  min-width: 78px;
  text-align: center;

  @media (min-width: ${styles.breakpoint.md}) {
    min-width: 122px;
  }
`;

const BarredText = () => (
  <Bars>
    <StyledTypography
      variant={VARIANTS.BODY}
    >
      or
    </StyledTypography>
  </Bars>
);

export default BarredText;
